import { Button, Col, Form, Input, Row, Typography } from 'antd';
import { UserOutlined } from '@ant-design/icons';
import { useLogin } from "../hooks/HookLogin";
import { PageLoading } from '../../../../../../component/PageLoading';

const onFinishFailed = errorInfo => {
    //console.log('Failed:', errorInfo);
};

const PasswordResetRequest = ({ onTabChange }) => {
    const [form] = Form.useForm();
    const { loading, onForgotPassword } = useLogin();

    const onFinish = async (values) => {
        await onForgotPassword(values);
        await onTabChange('1');
        form.resetFields();
    };

    return (
        <PageLoading loading={loading}>
            <Form
                name="passwordReset"
                form={form}
                style={{ maxWidth: 600 }}
                initialValues={{ remember: true }}
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                layout="vertical"
            >
                <Row align="middle" justify="center">
                    <Col
                        span={20}
                        style={
                            { marginBottom: '20px', marginTop: '20px' }
                        }
                    >
                        <Typography.Text strong>Por favor, ingrese su correo principal y recibirá un enlace para restablecer su contraseña.</Typography.Text>
                    </Col>
                    <Col span={20}>
                        <Form.Item
                            label="Correo electrónico"
                            name="correo"
                            rules={[
                                { required: true, message: '¡Por favor ingresa tu correo electrónico!' },
                                { whitespace: true },
                                { type: 'email', message: 'Por favor ingresa un correo valido' },
                                /* { pattern: /^[a-zA-Z0-9_.+-]+@seconalep\.mx$/, message: 'Por favor ingresa un correo con @seconalep.mx' }*/
                            ]}
                        >
                            <Input prefix={<UserOutlined />} placeholder="Ingresa tu correo electronico" />
                        </Form.Item>
                    </Col>
                    <Col>
                        <Form.Item label={null}>
                            <Button type="primary" htmlType="submit" loading={loading}>
                                Continuar con la recuperación
                            </Button>
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
        </PageLoading>
    )
};
export default PasswordResetRequest;